<ng-template>
	<div class="row">
		<div class="col-22 offset-1">
			<h3 class="text-center mx-auto mt-3">
				<ng-content></ng-content>
			</h3>
		</div>
	</div>
</ng-template>
